module.exports = __webpack_public_path__ + "static/img/AI.63bffde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/mobile/AI.png
// module id = Kxae
// module chunks = 12